






import Vue from 'vue';
import AuthLayout from '@/layouts/auth/index.vue';

export default Vue.extend({
  name: 'ViewAuth',

  components: {
    AuthLayout,
  },
});
